import { useContext } from "react"
import { Modal } from "react-bootstrap"
import LanguageContext from "./hooks/LanguageContext"
import { getText } from "../utils/languageUtils"

const ModalInstruction = ({ show, handleClose, inst, question }) => {
    const { language, languages, translations } = useContext(LanguageContext);
    
    // Check if current language video is available
    // Must have a non-empty link AND be different from English (or be the same if both exist)
    const currentLangVideo = question?.video_link?.[language];
    const englishVideo = question?.video_link?.['english'];
    const isCurrentLanguageAvailable = language === 'english' || 
        (currentLangVideo && currentLangVideo.trim() !== '' && currentLangVideo !== englishVideo);
    
    // Get display name for current language
    const currentLanguage = languages?.find(l => l.language_tag_full === language);
    const languageDisplayName = getText(currentLanguage?.title, language) || language;
    
    // Get translated messages
    const notAvailableText = translations?.modal_instruction?.not_available?.[language] || 
        `${languageDisplayName} version not available`;
    const availableText = translations?.modal_instruction?.available?.[language] || 
        `${languageDisplayName} version available`;

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Body>
                <div>
                    {inst}
                </div>

                <div>
                    {question?.question_type === 'video' && language !== 'english' && (
                        <div>
                            {!isCurrentLanguageAvailable ? (
                                <p className="text-start text-danger">{notAvailableText}</p>
                            ) : (
                                <p className="text-start text-success">{availableText}</p>
                            )}
                        </div>
                    )}
                </div>

            </Modal.Body>
        </Modal>
    )
}

export default ModalInstruction